import React, { FunctionComponent } from 'react'

import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { baseColors, Spinner, Text } from '@fairhq/common'
import { useGetCategoriesExperienceQuery } from 'store/category/categoryApi'

import { SubCategoryExperience } from 'store/category/types'

import { CategoryAccordion } from './CategoryAccordion'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const StyledText = styled(Text)`
  text-transform: uppercase;
  margin: 0;
`

const TableHader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  gap: 20px;
  color: ${baseColors.contentMuted};
`

const FakeColumnHeader = styled(StyledText)`
  width: 310px;
`

interface CategoriesProps {
  loading: boolean
  previousSurveyWindowId?: number
  categoryExperiences?: SubCategoryExperience[]
}

export const Categories: FunctionComponent<CategoriesProps> = ({
  loading,
  previousSurveyWindowId,
  categoryExperiences,
}) => {
  const { category } = useParams<{ category: string }>()

  const { data: previousExperienceCategory } = useGetCategoriesExperienceQuery(
    { category, surveyWindowId: previousSurveyWindowId },
    { skip: !category }
  )

  return (
    <Container>
      {loading && <Spinner center />}

      <TableHader>
        <StyledText element="p" type="body" size="2xs" fontWeight={700}>
          RISK FACTOR
        </StyledText>
        <FakeColumnHeader element="p" type="body" size="2xs" fontWeight={700}>
          EMPLOYEE EXPERIENCE
        </FakeColumnHeader>
      </TableHader>
      {categoryExperiences &&
        categoryExperiences?.length > 0 &&
        categoryExperiences.map(item => (
          <CategoryAccordion
            key={item.subCategory}
            categoryExperience={item}
            previousExperience={previousExperienceCategory?.find(
              previous => previous.subCategory === item.subCategory
            )}
          />
        ))}
    </Container>
  )
}
